/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IExtProductCollection containerModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';

export const enum layout {
    carousel = 'carousel',
    grid = 'grid'
}

export interface IExtProductCollectionConfig extends Msdyn365.IModuleConfig {
    productCollection: Msdyn365.IProductList;
    productCollectionMale?: Msdyn365.IProductList;
    heading?: IHeadingData;
    layout?: layout;
    allowBackNavigation?: boolean;
    imageSettings?: Msdyn365.IImageSettings;
    clientRender?: boolean;
    enableAffiliationBasedPricing?: boolean;
    shouldDisplaySeeAllButton?: boolean;
    className?: string;
    enableAvailabilityCheck?: boolean;
}

export interface IExtProductCollectionResources {
    priceFree: string;
    priceRangeSeparator: string;
    ratingAriaLabel: string;
    flipperNext: string;
    flipperPrevious: string;
    originalPriceText: string;
    currentPriceText: string;
    ratingCountAriaLabel: string;
    ratingCountAriaLabelSingleUser: string;
    seeAllButtonText: string;
    memberPriceMessage: string;
    saleMessage: string;
}

export const enum HeadingFontFamily {
    ConvEuropaBold = 'ConvEuropaBold',
    ConvEuropaRegular = 'ConvEuropaRegular',
    ConvEuropaLight = 'ConvEuropaLight',
    BodoniRegular = 'BodoniRegular',
    BodoniSmallCaps = 'BodoniSmallCaps',
    BodoniBold = 'BodoniBold',
    BodoniOSRegular = 'BodoniOSRegular',
    BodoniOSBold = 'BodoniOSBold',
    BodoniOSItalic = 'BodoniOSItalic',
    HelveticaNeue = 'HelveticaNeue',
    HelveticaNeueBold = 'HelveticaNeueBold',
    HelveticaNeueLight = 'HelveticaNeueLight',
    Manus = 'Manus'
}

export interface IHeadingData {
    text: string;
    fontFamily: HeadingFontFamily;
    fontSize: number;
    fontColor: string;
}

export interface IExtProductCollectionProps<T> extends Msdyn365.IModule<T> {
    resources: IExtProductCollectionResources;
    config: IExtProductCollectionConfig;
    slots: {
        quickview: React.ReactNode[];
        productComparisonButton: React.ReactNode[];
    };
}
